import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs';

import { selectFeatureFlags } from '@core/stores/auth/auth.selectors';

import { FeatureFlags } from '@domain/tenant/tenant.enums';

export const createFeatureGuard =
  (featureFlags: FeatureFlags | FeatureFlags[]): CanActivateFn =>
  () => {
    const store = inject(Store);
    const router = inject(Router);

    return store.select(selectFeatureFlags).pipe(
      filter((flags) => !!flags),
      map((flags) => {
        const redirectCommandToHome = new RedirectCommand(router.createUrlTree(['/']), {
          replaceUrl: true,
        });

        if (Array.isArray(featureFlags)) {
          return featureFlags.some((flag) => flags.includes(flag)) || redirectCommandToHome;
        }

        return flags.includes(featureFlags) || redirectCommandToHome;
      })
    );
  };
